import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex w-full flex-col items-center justify-center px-4 py-28 text-center md:px-6">
      <div className="relative">
        <span className="font-heading text-7xl font-black text-background-200 md:text-9xl">404</span>
      </div>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">页面未找到</h1>
      <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
        你访问的页面不存在或已被移除。可以返回首页，或从下面的入口继续浏览影视内容。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors duration-200 hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/movies"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm font-label text-foreground-800 transition-colors duration-200 hover:border-primary-500/60 hover:text-primary-400"
        >
          <i className="ri-film-line" />
          浏览电影
        </Link>
        <Link
          to="/news"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm font-label text-foreground-800 transition-colors duration-200 hover:border-primary-500/60 hover:text-primary-400"
        >
          <i className="ri-newspaper-line" />
          影视资讯
        </Link>
      </div>
    </div>
  );
}